import React from 'react';
import Link from 'next/link';
import Router from 'next/router';
import Image from 'next/image';
import { isServer } from '../../../src/environment';
import { CartItem } from '../../../src/common/components';
import { useCart } from '../../../src/common/context/CartContext';
import { PageTitle } from '../../../src/common/utils/react-helmet-helpers';
import stripeLogo from '../../../src/assets/img/stripe.png';

export default function CartPage() {
  const { cartItems: localStorageCartItems, getItemVariation } = useCart();

  const [cartItems, setCartItems] = React.useState([]);

  React.useEffect(() => {
    setCartItems(localStorageCartItems);
  }, [localStorageCartItems]);

  function routeBack() {
    Router.back();
  }

  function routeToCheckout() {
    Router.push(`/${Router.query.accessCode}/checkout`);
  }

  function getSubtotal() {
    if (cartItems.length < 1) {
      return 0;
    }
    return cartItems.map((item) => (getItemVariation(item)?.getOnlinePrice || 0) * item.qty).reduce((a, b) => a + b);
  }
  const cartItemList = cartItems.map((item) => <CartItem key={item.uuid} item={item} />);

  function renderCartWithItemsState() {
    return (
      <>
        <p className="mutedText">
          Each item is custom made upon ordering. Please allow 1-3 business days to produce. Orders ship from Utah.
        </p>
        <div className="cart__items">{cartItemList}</div>
        <div className="cart__right">
          <p className="textMargin">
            <strong>Subtotal: ${getSubtotal().toFixed(2)}</strong>
          </p>
          <p className="textMargin">Plus Shipping</p>
        </div>
        <p className="mutedText">
          You will receive a confirmation email with your order information when payment is complete.
        </p>
        <div className="cart__checkout">
          <button className="button" onClick={routeToCheckout}>
            To Checkout
          </button>
          <div className="stripeImg">
            <Image src={stripeLogo} alt="Powered By Stripe" />
          </div>
        </div>
      </>
    );
  }

  function renderCartEmptyState() {
    return (
      <>
        <p className="cart__empty">
          Your cart is empty.{' '}
          <Link href="/" passHref>
            <a className="link">Click here</a>
          </Link>{' '}
          to continue shopping.
        </p>
        <div className="cart__checkout">
          <div className="stripeImg">
            <Image src={stripeLogo} alt="Powered By Stripe" />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <PageTitle>Cart</PageTitle>
      <div className="cart">
        <div className="cart__header">
          <button className="iconButton--gray" title="Back" onClick={routeBack}>
            <i className="fas fa-angle-left fa-fw" aria-hidden="true"></i> <span className="hideOnMobile">Back</span>
          </button>
          <h1 className="cart__title">Cart</h1>
        </div>
        <div className="coloredDivider"></div>
        <div className="boxedContainer">
          <div className="cart__content">
            {cartItems?.length > 0 && renderCartWithItemsState()}
            {cartItems?.length < 1 && renderCartEmptyState()}
          </div>
        </div>
      </div>
    </>
  );
}
